module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-alert"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-alert",
    class: [_vm.typeClass, _vm.center ? 'is-center' : '', 'is-light'],
    style: (("width:" + _vm.size)),
    attrs: {
      "role": "alert"
    }
  }, [(_vm.showIcon) ? _c('rt-icon', {
    class: ("rt-alert-" + _vm.type),
    attrs: {
      "name": ("rt-base-alert-" + _vm.type),
      "size": "16"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content el-alert__title"
  }, [_vm._t("title", function() {
    return [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
  })], 2), _vm._v(" "), _c('rt-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closable),
      expression: "closable"
    }],
    staticClass: "rt-message-close",
    attrs: {
      "icon-name": _vm.closeText === '' ? 'rt-base-close-x' : '',
      "text": "",
      "icon-size": "16"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [(_vm.closeText) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.closeText) + "\n      ")]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-923e58ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/alert/rtAlert.vue
// module id = 2143
// module chunks = 228